export class Controller {
    /** @ngInject */
    constructor($state, Alert, AuthenticationAccessPolicyResource, ConfirmModal) {
        this.$state = $state;
        this.Alert = Alert;
        this.AuthenticationAccessPolicyResource = AuthenticationAccessPolicyResource;
        this.ConfirmModal = ConfirmModal;
    }

    $onInit() {
        const updateOrder = (array,search) =>{
            let i = array.findIndex(o => o.policyName === search);
            if (i === 0) return;
            else return array.unshift(array.splice( i, 1 )[0]);
        }
        updateOrder(this.policies,'Default Policy')
    }

    addPolicy() {
        this.isAdding = true;
        this.AuthenticationAccessPolicyResource.createAuthenticationAccessPolicy(this.companyId)
        	.then((data)=>{this.policies.push(data);this.$state.go('company.policies.authentication-access-policies.edit',{policyId: data.id})})
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.added'))
            .finally(() => (this.isAdding = false));
    }

    removePolicy(policy) {
        this.isRemoving = policy;
        this.ConfirmModal()
            .then(() => this.AuthenticationAccessPolicyResource.deleteAuthenticationAccessPolicy(this.companyId, policy.id),)
            .then(() => this.$state.reload('company.policies'))
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.removed'))
            .finally(() => (this.isRemoving = null));
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/authentication-access-policies/authentication-access-policies.controller.js